import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { FilterType } from '@enums/FilterType.ts';

export type MobileFilterType = FilterType | 'mobile_filters';

export const useFilterStore = defineStore('filter', () => {
  const openedFilter = ref<FilterType | null>(null);
  // @todo use a objectFilter instead of many ref, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-10559
  const teamSizeMin = ref<number | null>(null);
  const teamSizeMax = ref<number | null>(null);
  const enableAggregate = ref<boolean>(true);
  const stepMobileFilterStack = ref<MobileFilterType[]>([]);

  const isFilterOpen = computed<boolean>(() => openedFilter.value !== null || stepMobileFilterStack.value.length > 0);
  const currentMobileFilterStep = computed<MobileFilterType | null>(() => stepMobileFilterStack.value[stepMobileFilterStack.value.length - 1] || null);

  const setDesktopFilter = (label: FilterType | null): void => {
    openedFilter.value = label;
  };

  const toggleEnableAggregate = (): void => {
    enableAggregate.value = !enableAggregate.value;
  };

  const openMobileFilter = (type: MobileFilterType): void => {
    stepMobileFilterStack.value.push(type);
  };

  const closeMobileFilter = (): void => {
    stepMobileFilterStack.value.pop();
  };

  const closeAllMobileFilters = (): void => {
    stepMobileFilterStack.value = [];
  };

  return {
    openedFilter,
    teamSizeMin,
    teamSizeMax,
    enableAggregate,
    stepMobileFilterStack,
    isFilterOpen,
    setDesktopFilter,
    toggleEnableAggregate,
    openMobileFilter,
    closeMobileFilter,
    closeAllMobileFilters,
    currentMobileFilterStep,
  };
});
